// extracted by mini-css-extract-plugin
module.exports = {"close":"_9e1425b4d3--close--g3sc2"};